'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _browserWurfl = require('browser-wurfl');

var _browserWurfl2 = _interopRequireDefault(_browserWurfl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * The TextInput component with floating label capability
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Floating Label design pattern
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * http://www.google.com/design/spec/components/text-fields.html#text-fields-floating-labels
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * http://bradfrost.com/blog/post/float-label-pattern/
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var COLORS = {
  blue: '#0070ba',
  gray: '#6c7378'
};

var STYLES = {
  textInput: {
    width: '100%',
    height: 'auto',
    padding: 0,
    margin: '10px 0',
    position: 'relative',
    display: 'table',
    tableLayout: 'fixed'
  },

  placeholder: {
    padding: 0,
    position: 'absolute',
    top: 16,
    left: 12,
    color: COLORS.gray,
    fontSize: 15,
    lineHeight: '20px',
    fontWeight: 'normal', // forcing normal weight since vx_form-group styles all labels with bold

    WebkitTransition: 'all 0.25s ease-in-out',
    MozTransition: 'all 0.25s ease-in-out',
    msTransition: 'all 0.25s ease-in-out',
    OTransition: 'all 0.25s ease-in-out',
    transition: 'all 0.25s ease-in-out',

    WebkitTransform: 'translate3d(0,0,0)',
    MozTransform: 'translate3d(0,0,0)',
    msTransform: 'translate3d(0,0,0)',
    OTransform: 'translate3d(0,0,0)',
    transform: 'translate3d(0,0,0)',

    WebkitTransformOrigin: 'left top',
    MozTransformOrigin: 'left top',
    msTransformOrigin: 'left top',
    OTransformOrigin: 'left top',
    transformOrigin: 'left top'
  },

  floatLabel: {
    color: COLORS.blue,
    WebkitTransform: 'translate(1px, -6px) scale(0.75)',
    MozTransform: 'translate(1px, -6px) scale(0.75)',
    msTransform: 'translate(1px, -6px) scale(0.75)',
    OTransform: 'translate(1px, -6px) scale(0.75)',
    transform: 'translate(1px, -6px) scale(0.75)'
  },

  input: {
    width: '100%',
    height: 50,
    padding: 10,
    margin: 0,
    display: 'table-cell',
    boxSizing: 'border-box',
    border: '1px solid',
    borderColor: COLORS.gray,
    borderRadius: 5,
    background: '#fff',
    fontSize: 15,
    lineHeight: '20px',

    WebkitTransition: 'all 0.25s ease-in-out',
    MozTransition: 'all 0.25s ease-in-out',
    msTransition: 'all 0.25s ease-in-out',
    OTransition: 'all 0.25s ease-in-out',
    transition: 'all 0.25s ease-in-out'
  }

  /**
   * Check if value actually has a value (not undefined, not null, not empty string)
   * @param  {String|Number}  value the input value
   * @return {Boolean}        if the value actually has some value
   */
};var hasValue = function hasValue(value) {
  return value !== undefined && value !== null && value !== '';
};

var TextInput = function (_Component) {
  _inherits(TextInput, _Component);

  function TextInput() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, TextInput);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TextInput.__proto__ || Object.getPrototypeOf(TextInput)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      hovered: false,
      focused: false,
      floatLabel: hasValue(_this.props.value),
      placeholder: ''

      /**
       * Clear the timeout when we're about to unmount
       */
    }, _this.handleMouseOver = function (event) {
      _this.props.onMouseOver(event);
      _this.setState(function () {
        return { hovered: true };
      });
    }, _this.handleMouseOut = function (event) {
      _this.props.onMouseOut(event);
      _this.setState(function () {
        return { hovered: false };
      });
    }, _this.handleFocus = function (event) {
      _this.props.onFocus(event);
      _this.setState(function () {
        return {
          focused: true
        };
      });

      // wait until the label floating up animation is done before we show the placeholder
      _this._timeoutID = setTimeout(function () {
        if (_this.state.floatLabel && !!_this.props.label) {
          _this.setState(function (state, props) {
            return { placeholder: props.helpText };
          });
        }
      }, 150);
    }, _this.handleBlur = function (event) {
      _this.props.onBlur(event);
      _this.setState(function () {
        return {
          focused: false,
          placeholder: ''
        };
      });
    }, _this.focusIn = function () {
      setTimeout(function () {
        return _this._input.focus();
      }, 0);
    }, _this.renderClearInput = function () {
      if (_browserWurfl2.default.canShowClearInput && hasValue()) {
        return _react2.default.createElement('div', { className: 'clearInput icon-close-small', onClick: _this.focusIn });
      }

      return null;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(TextInput, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.clearTimeout(this._timeoutID);
    }

    /**
     * Decide if we should float the label if the value has changed
     * @param  {Object} props the next props
     */

  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      // strip out custom props and only get the props an <input> can consume
      var _props = this.props,
          className = _props.className,
          helpText = _props.helpText,
          wrapperDataAttributes = _props.wrapperDataAttributes,
          _props$styles = _props.styles,
          styles = _props$styles === undefined ? {} : _props$styles,
          _props$innerRef = _props.innerRef,
          innerRef = _props$innerRef === undefined ? function () {} : _props$innerRef,
          inputProps = _objectWithoutProperties(_props, ['className', 'helpText', 'wrapperDataAttributes', 'styles', 'innerRef']);

      var IS_VX = !!(className && className.includes('vx_'));
      var shouldFloatLabel = this.state.floatLabel && !!this.props.label;

      // text input wrapper styles
      var textInputStyles = _extends({}, IS_VX ? { position: 'relative' } : STYLES.textInput, styles.textInput);

      // add the floated label styles if the label sholuld be floated
      var labelStyles = _extends({}, STYLES.placeholder, styles.placeholder);
      if (shouldFloatLabel) {
        labelStyles = _extends({}, labelStyles, STYLES.floatLabel, {
          color: this.state.focused ? COLORS.blue : COLORS.gray
        }, styles.floatLabel);
      }

      // if dir is rtl, flip the position of the placeholder
      if (this.props.dir === 'rtl') {
        labelStyles = _extends({}, labelStyles, { left: 'auto', right: 12 });
      }

      // move the actual inuput down when the label is floated
      // change the border color based on if the text input should be highlighted
      var borderColor = this.state.hovered || this.state.focused ? COLORS.blue : COLORS.gray;
      var inputStyles = {};
      if (!IS_VX) {
        inputStyles = _extends({}, inputStyles, STYLES.input);
      }
      inputStyles = _extends({}, inputStyles, {
        padding: shouldFloatLabel ? '16px 12px 0' : 12,
        borderColor: borderColor
      }, styles.input);

      // decide if we should handle events when input is readonly
      var handlers = !this.props.readOnly && {
        onMouseOver: this.handleMouseOver,
        onMouseOut: this.handleMouseOut,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur
      };

      return _react2.default.createElement(
        'div',
        _extends({
          className: className,
          style: textInputStyles
        }, wrapperDataAttributes),
        _react2.default.createElement(
          'label',
          { htmlFor: this.props.id, style: labelStyles },
          this.props.label
        ),
        _react2.default.createElement('input', _extends({}, inputProps, {
          ref: function ref(c) {
            _this2._input = c;
            innerRef(c);
          },
          placeholder: this.state.placeholder,
          'aria-label': this.props.label,
          style: inputStyles
        }, handlers)),
        _react2.default.createElement('span', { className: 'vx_form-control-error-icon icon icon-small icon-critical-small' }),
        this.renderClearInput()
      );
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(props, state) {
      return {
        floatLabel: hasValue(props.value) || state.focused
      };
    }

    /**
     * Float the label on focus
     */


    /**
     * Don't float the label on blur, but keep it floated if there's an input value
     */


    /**
     * Renders the clear input button for touch devices not on IE>10 where -ms-clear is used
     * @return {ReactElement} clear input button
     */

  }]);

  return TextInput;
}(_react.Component);

TextInput.propTypes = {
  className: _propTypes2.default.string,
  label: _propTypes2.default.string,
  helpText: _propTypes2.default.string,

  type: _propTypes2.default.string,
  name: _propTypes2.default.string.isRequired,
  id: _propTypes2.default.string.isRequired,
  wrapperDataAttributes: _propTypes2.default.object,

  autoComplete: _propTypes2.default.string,
  dir: _propTypes2.default.string,
  disabled: _propTypes2.default.bool,
  max: _propTypes2.default.number,
  maxLength: _propTypes2.default.number,
  min: _propTypes2.default.number,
  minLength: _propTypes2.default.number,
  pattern: _propTypes2.default.string,
  readOnly: _propTypes2.default.bool,
  required: _propTypes2.default.bool,

  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  onMouseOver: _propTypes2.default.func,
  onMouseOut: _propTypes2.default.func,
  onFocus: _propTypes2.default.func,
  onBlur: _propTypes2.default.func,
  onChange: _propTypes2.default.func,

  styles: _propTypes2.default.object, // override for STYLES object
  innerRef: _propTypes2.default.func
};
TextInput.defaultProps = {
  type: 'text',
  readOnly: false,
  onMouseOver: function onMouseOver() {},
  onMouseOut: function onMouseOut() {},
  onFocus: function onFocus() {},
  onBlur: function onBlur() {},
  onChange: function onChange() {},
  styles: {}
};
exports.default = TextInput;


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/react-expiry-date/~/react-text-input/dist/index.js
// module id = 1027
// module chunks = 5